import React, { Component }  from 'react';
import { CardWarning } from '../../../widgets/Cards';



class Billing extends Component {

    contentList() {
        return <div>Item 721 and 723 is available<br></br>
                    Item 10997 is available
        </div>
    }

    content() {
        return (
            <>
            <h2 style={{marginTop:"-10px"}}>Billing</h2>
            {this.contentList()}
            </>
        )
    }

    render() {
        return (
            <CardWarning
                color = "green"
                content = {this.content()}
                icon = 'scroll'
            />
        )
        
    }
}

export default Billing;